var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_1806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2405 37.3816L20.2744 5.41733H35.9147C37.1443 5.41733 38.1425 4.42093 38.1425 3.18956C38.1425 1.95819 37.1443 0.961792 35.913 0.961792H14.9903C14.9727 0.961792 14.9568 0.963559 14.9409 0.963559C14.349 0.949425 13.7519 1.16673 13.2996 1.61899C12.4216 2.49703 12.4216 3.91919 13.2996 4.79722L49.0623 40.5599C49.5004 40.998 50.0763 41.2188 50.6505 41.2188C51.2247 41.2188 51.8006 40.9998 52.2387 40.5599C53.1168 39.6818 53.1168 38.2597 52.2387 37.3816H52.2405Z",
    fill: "#FF7324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5981 50.0221L3.83725 14.2595C2.95921 13.3814 1.53705 13.3814 0.659013 14.2595C-0.21902 15.1375 -0.21902 16.5597 0.659013 17.4377L32.6251 49.4038H16.9865C15.7569 49.4038 14.7588 50.4002 14.7588 51.6315C14.7588 52.8629 15.7552 53.8593 16.9865 53.8593H37.9092C37.9251 53.8593 37.941 53.8575 37.9586 53.8575C37.9763 53.8575 37.994 53.8593 38.0099 53.8593C38.5858 53.8593 39.16 53.6402 39.5981 53.2003C40.4761 52.3223 40.4761 50.9001 39.5981 50.0221Z",
    fill: "#FF7324"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_1806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0 0.961792)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrade);
export default __webpack_public_path__ + "static/media/IconTrade.9df96c0ef78acd3141e65cf33f55f562.svg";
export { ForwardRef as ReactComponent };